import Vue from 'vue'
import App from './opportuntity/app.vue'
import TurbolinksAdapter from 'vue-turbolinks';
import VueTippy, { TippyComponent } from "vue-tippy";

Vue.use(TurbolinksAdapter)
Vue.use(VueTippy);
Vue.component("tippy", TippyComponent);

document.addEventListener('turbo:load', () => {
  const opportunity = document.getElementById('opportunity-vue');

  if (opportunity) {
    new Vue({
      el: '#opportunity-vue',
      render: h => h(App)
    }).$mount();
  }
});